import Home from './Home';

const index = {
  Home,
};

export default index;